import { AxiosResponse } from 'axios';
import HttpClient from '../HttpClient';
import { LanguageResponseType } from './model';

class LanguageService {
  private httpBoka: HttpClient;

  public constructor(http: HttpClient) {
    this.httpBoka = http;
  }

  public getLanguagesForCountryCode = async (
    countryCode: string,
  ): Promise<AxiosResponse<LanguageResponseType>> => {
    return this.httpBoka.get(`/country/${countryCode}`);
  };
}

export default LanguageService;
